HTMLElement.prototype.slideToggle = function () {
  if (this.classList.contains('active')) {
    this.style.height = null

    this.addEventListener('transitionend', () => {
      this.classList.remove('active')
    }, { once: true })

    return false
  }

  this.classList.add('active')
  this.style.height = 'auto'
  const height = this.clientHeight + 'px'
  this.style.height = '0px'

  setTimeout(() => {
    this.style.height = height
  }, 0)
}



// WEBPACK FOOTER //
// ./themes/default/js/vendor/helpers.js